import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setNextFormStep, setPreviousFormStep, setInitialFormStep } from 'actions/form';

type FormStepState = number;
interface UseCreateJobPostStep {
  formStep: FormStepState;
  setNextFormStepHandler: any;
  setPreviousFormStepHandler: any;
  setInitialFormStepHandler: any;
}

const useCreateJobPostStep = (): UseCreateJobPostStep => {
  const formStep = useSelector<any, FormStepState>(state => state.formStep);
  const dispatch = useDispatch();
  const setNextFormStepHandler = useCallback(() => dispatch(setNextFormStep()), [dispatch]);
  const setPreviousFormStepHandler = useCallback(() => dispatch(setPreviousFormStep()), [dispatch]);
  const setInitialFormStepHandler = useCallback(() => dispatch(setInitialFormStep()), [dispatch]);

  useEffect(() => {
    return () => {
      setInitialFormStepHandler();
    };
  }, [setInitialFormStepHandler]);

  return {
    formStep,
    setNextFormStepHandler,
    setPreviousFormStepHandler,
    setInitialFormStepHandler,
  };
};

export default useCreateJobPostStep;
